/******************************************************************
 * ##: Device (tablet) identifier
 * Stable per-tablet id persisted in localStorage. It is preserved across the login
 * storage wipe (see LoginForm clearAllSiteData) so it stays constant for the device.
 *
 * TL;DR: Get (or create) a stable id for this tablet.
 * History:
 * 23-07-2026: Created
 ******************************************************************/

import uniqid from "uniqid";

const DEVICE_ID_KEY = "md-device-id";

const generateUuid = () => {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch (error) {
    // Fall through to the uniqid fallback.
  }
  return uniqid("device-");
};

/**
 * Return this tablet's stable id, creating and persisting one on first use.
 * @returns {string|null} The device id, or null when storage is unavailable.
 */
export const getDeviceId = () => {
  try {
    if (typeof localStorage === "undefined") return null;
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = generateUuid();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch (error) {
    return null;
  }
};
